import {SODeleteInvoiceLine} from '../../core/invoice-line/so-delete-invoice-line';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteInvoiceLine extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteInvoiceLine;
}